module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billctl"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("账单管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("打款时间")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "relative",
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "265px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期范围",
      "size": "small",
      "clearable": false,
      "editable": false
    },
    on: {
      "change": _vm.changeDateRange
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "remark note ml-0"
  }, [_vm._v("* 请不要跨月查询")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.role.single),
      expression: "!role.single"
    }],
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.recordHref,
      "download": "true"
    }
  }, [_c('div', {
    staticClass: "panel-btn__download panel-btn__download_record"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载打款记录")])])])])])], 1)]), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-body__fix"
  }, [_c('div', {
    staticClass: "panel-paragraph"
  }, [_c('p', [_vm._v("账单是T+1生成，即交易后的第二个工作日，请在相应日期下载对账单")]), _vm._v(" "), _c('p', [_vm._v("相应的钱款也是T+1清算。")]), _vm._v(" "), _c('p', [_vm._v("例：周五、周六、周日的款项会在下周一清算，节假日会在节假日后的第一个工作日清算")])]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-paragraph"
  }, [_c('p', [_vm._v("合作的清算方名称如下，请在对账时下载银行卡相应的流水单")]), _vm._v(" "), _c('p', [_vm._v("联动优势电子商务有限公司客户备付金")]), _vm._v(" "), _c('p', [_vm._v("商户结算专户")]), _vm._v(" "), _c('p', [_vm._v("昆明结算中心")]), _vm._v(" "), _c('p', [_vm._v("扫码支付专户")]), _vm._v(" "), _c('p', [_vm._v("网银在线")]), _vm._v(" "), _c('p', [_vm._v("财付通")]), _vm._v(" "), _c('p', [_vm._v("银联支付")])]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-paragraph"
  }, [_c('p', [_vm._v("如您已成为微信实名认证商户，请在微信商户后台查看微信交易的对账单。"), _c('a', {
    staticClass: "paragraph-link",
    attrs: {
      "target": "_blank",
      "href": "https://pay.weixin.qq.com/index.php"
    }
  }, [_vm._v("点此跳转")])]), _vm._v(" "), _c('p', [_vm._v("商户管理后台仅提供非微信交易的对账单，如支付宝、京东等。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bada815"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billctl/billctl.vue
// module id = 802
// module chunks = 1